export const styles = {
  link: {
    color: 'rgba(0, 0, 0, 0.87)',
    textDecoration: 'none',
  },
};
